import React, { useState, useEffect } from 'react';
import Game from '../Game';
import sequence from '../../practice-sequence.json';
import Flasher from '../Flasher';
import './style.css';

const gameConfig = {
  // gameColor: 'blue', // Background color
  // feedbackColor: 'yellow', // Box color
  roundsAmount: sequence.length,
  // triesAmount: 2,
  timeToRespond: 2000,
  // timeToRespond: 0,
  timeBetweenRound: 250, // Time between responses (reduced for quicker next key)
  boxesAmount: 4, // Number of boxes
  letterHint: false,
  possibleKeys: ['C', 'V', 'N', 'M'],
  // letterHint: true, // If the letter is shown on the box
  letterPerBox: sequence,
};

const PracticeRound = ({ setIsNextDisabled, nextStep }) => {
  const [screenFlashed, setScreenFlashed] = useState(false);
  const [isPracticeFinished, setIsPracticeFinished] = useState(false);
  const [, setUmounted] = useState(false);
  const flashScreen = () => {
    setScreenFlashed(true);
  };

  const endGame = () => {
    setIsNextDisabled(false);
    setIsPracticeFinished(true);
    // //click the next button : 
    // nextStep();
  };

  useEffect(() => {
    setIsNextDisabled(true);
    return () => setUmounted(true);
  }, [setIsNextDisabled]);

  useEffect(() => {
    if (!isPracticeFinished) return;
    const handleKey = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        document.removeEventListener('keydown', handleKey);
        nextStep();
      }
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isPracticeFinished, nextStep]);

  return (
    <>
      <Game
        gameConfig={gameConfig}
        endGame={endGame}
        flashScreen={flashScreen}
        isPracticeRound={true}
      />
      {isPracticeFinished && (
        <div className="practice-round-text">
          <p>You did great! Press Enter or click Next to continue.</p>
        </div>
      )}
      <Flasher
        messageDurationSeconds={1}
        screenFlashed={screenFlashed}
        setScreenFlashed={setScreenFlashed}
      />
    </>
  );
};

export default PracticeRound;
